export const OFFLINE_STATUS_CHANGED = 'Offline/STATUS_CHANGED';
export const OFFLINE_SCHEDULE_RETRY = 'Offline/SCHEDULE_RETRY';
export const OFFLINE_COMPLETE_RETRY = 'Offline/COMPLETE_RETRY';
export const OFFLINE_SEND = 'Offline/SEND';
export const OFFLINE_BUSY = 'Offline/BUSY';
export const OFFLINE_ENQUEUE = 'Offline/ENQUEUE';
export const RESET_STATE = 'Offline/RESET_STATE';
export const JS_ERROR = 'Offline/JS_ERROR';
export const DEFAULT_COMMIT = 'Offline/DEFAULT_COMMIT';
export const DEFAULT_ROLLBACK ='Offline/DEFAULT_ROLLBACK';
